// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SL4_","type":"styles_type__o9msZ","choices":"styles_choices__2Zwwb"};